import React from 'react';
import { BsPencilSquare, BsPrinter } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Box, HStack, Icon, IconButton, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import StatusBadge from '../../../../../../../components/StatusBadge';
import { selectCompanyId } from '../../../../../../../redux/modules/company';
import { hideTray } from '../../../../../../../redux/modules/tray';
import colors from '../../../../../../../styles/theme/foundation/colors';
import editTemplate from '../../../../../util/editTemplate';

import '../styles.css';

function TemplatePreviewHeader({ template }) {
  const isArchived = template.archivedAt;
  const textColor = isArchived ? colors.greyScale['800'] : colors.greyScale['900'];
  const history = useHistory();
  const { url } = useRouteMatch();
  const dispatch = useDispatch();
  const companyId = useSelector(selectCompanyId);

  return (
    <VStack height="auto" justify="space-between" pb={3} pt={8} px={6}>
      <Box
        color={textColor}
        overflowWrap="anywhere"
        textAlign="center"
        textStyle="bodyXl600"
      >
        {template.name}
      </Box>
      <Box
        overflowWrap="anywhere"
        textAlign={template.description ? 'left' : 'center'}
        textStyle="bodyMd"
      >
        {template.description || <i>No description</i>}
      </Box>
      <HStack justifyContent="center" width="100%">
        <IconButton
          icon={<Icon as={BsPrinter} boxSize="21px" />}
          size="sm"
          variant="accent"
          onClick={() => window.print()}
        />
        {isArchived
          ? <StatusBadge size="sm" status="archived" />
          : (
            <IconButton
              icon={<Icon as={BsPencilSquare} boxSize="21px" />}
              size="sm"
              variant="accent"
              onClick={() => {
                editTemplate({ dispatch, history, id: template.id, companyId });
                dispatch(hideTray());
              }}
            />
          )}

      </HStack>
    </VStack>
  );
}

TemplatePreviewHeader.propTypes = {
  template: PropTypes.shape({
    id: PropTypes.number,
    archivedAt: PropTypes.oneOf(PropTypes.instanceOf(Date), PropTypes.string),
    name: PropTypes.string,
    description: PropTypes.string
  })
};

export default TemplatePreviewHeader;
